export const TITLE_SIGNUP = `Sign Up. «TANKIMODS.NET»`

export const ERROR_PROBLEM_CORRECT = `Неверный логин или пароль.`

export const ERROR_PROBLEM_ALL = `Ошибка регистрации. (error_code: 500)`

export const ERROR_PROBLEM_401 = `Ошибка регистрации. (error_code: 401)`

export const FIELD_SIGNUP_ERROR_TYPES = {
    LOGIN_MAX_LIMIT: 'Error! Max length - 50 symbols.',
    PASS_MAX_LIMIT: 'Error! Max length - 100 symbols.',
    FIELDS_EXCEPTED: `Заполните поля Логин и Пароль.`,
    FIELDS_EXCEPTED_LOGIN: `Заполните поле Логин.`,
    FIELDS_EXCEPTED_PASS: `Заполните поле Пароль.`,
    FIELDS_PASS_INCORRECT: `Пароли не совпадают.`,
}

export const SIGN_UP = `Регистрация`

export const SIGNUP_BUTTON_OK = `Продолжить`
export const SIGNUP_BUTTON_TO_LANDING = `На главную`

export const ERROR_PROBLEM_SIGN_UP = `Не удаётся зарегистрироваться?`

export const PASSWORD_RECOVERY = `Обратиться в поддержку`